// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CTABlock_wrapper__36E1G","leftbox":"CTABlock_leftbox__1q9tm","text":"CTABlock_text__2obHS","rightbox":"CTABlock_rightbox__1D4Fz","doctor":"CTABlock_doctor__3VEKz"};